import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import { IPomReportingListItem } from "../../../domain/reporting/pom-reporting";
import { PomReportingConverter } from "../../models/converter/pom-reporting.converter";
import { IPomReportingListModel } from "../../models/reportings/pom-reporting-list.model";
import { PomQueryKeys } from "../../pom-query-keys";
import getInstance from "../../../utils/rest";

const getReportingList = async (contractNo: string): Promise<IPomReportingListItem[]> => {
  const result = await getInstance().get<IPomReportingListModel>(`${RestEndpoints.PomReportings}/${contractNo}`);
  return PomReportingConverter.toReportingList(result.data);
};

export const useGetReportingListQuery = (contractNo: string | undefined) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetReportingList, contractNo],
    queryFn: () => getReportingList(contractNo as string),
    staleTime: ReactQueryConfig.staleTime,
    enabled: !!contractNo,
  });
};
